import { useIsClient } from "@uidotdev/usehooks";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { getCompanyLogoImage } from "../../../../helpers/data_management";
import { BoxContainer, ButtonStyled, LinkWrapper } from "../styles";
import {
  CompanyDetailContainer,
  CompanyImage,
  CompanyName,
  JobCount,
  JobIcon,
  JobTitle,
  JobTitleCard,
  JobTitleContainer,
  LinkStyled,
} from "./styles";

export default function ExpiredJobTitle(props) {
  const { job } = props;
  const router = useRouter();
  const isClient = useIsClient();

  // Determine which company data to use based on cross-border status
  // If job is cross-bordered, use source country's company data
  const company =
    job?.crossedBorder &&
    job?.crossBorderData?.source_country !=
      process.env.NEXT_PUBLIC_JSW_GEOLOCATION.toUpperCase()
      ? job?.crossBorderData?.company
      : job?.company;

  // Memoized company logo URL to prevent unnecessary recalculations
  const companyLogo = useMemo(() => {
    return getCompanyLogoImage(company);
  }, [company]);

  // Handler for navigating to company profile page
  function handleViewCompanyProfile() {
    router.push(`/companies/${job.company.slug}`);
  }

  return (
    <JobTitleCard>
      <BoxContainer gap={"1.5rem"} width={"100%"}>
        <CompanyImage src={companyLogo} />
        <JobTitleContainer>
          <JobTitle>{job.title}</JobTitle>
          <CompanyDetailContainer>
            <LinkStyled href={`/companies/${job.company.slug}`} target="_blank">
              <CompanyName>{job.company.name}</CompanyName>
            </LinkStyled>
            {isClient && job.company.jobCount > 0 && (
              <BoxContainer gap={"0.25rem"} alignItems={"center"}>
                <JobIcon />
                <JobCount>{job.company.jobCount} jobs</JobCount>
              </BoxContainer>
            )}
          </CompanyDetailContainer>
        </JobTitleContainer>
      </BoxContainer>
      {isClient && (
        <LinkWrapper href={`/companies/${job.company.slug}`}>
          <ButtonStyled onClick={handleViewCompanyProfile}>
            View Company Profile
          </ButtonStyled>
        </LinkWrapper>
      )}
    </JobTitleCard>
  );
}
